import Basic from '@/components/page/Basic.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'

export default{
	extends: Basic,
	data: function () {
		return {
			ytd: {
				sales:{ rekap:[], nonpso:[], pso:[], store:[], spbu:[], other:[], keagenan:[], vendor:[], ytdchart:{}, mtdchart:{} }, 
				margin:{ rekap:[], nonpso:[], pso:[], store:[], spbu:[], other:[], keagenan:[], vendor:[], ytdchart:{}, mtdchart:{} }
			}, 
			monthly: { sales:[], margin:[] },
			keagenan: {
				total: 0,
				list:[],
				province:[],
				progress:[],
			},
			loading: { table:true },
		}	
	},
    methods:{
	
		async loadSales() {
			let url = Config().apiURL + "/lpg/sales2?period=monthly&pso=bypso&date-range-start=" + Penanggalan().tahunSekarang + "&date-range-end=" + Penanggalan().kemarin;
			await AxiosWithJar().get(url).then(result => {
				if (result.data.data.length) {
					this.monthly = {
						sales: this.processBarChart(result.data.data, "StatusPSO", "", "TotalSalesExTax", false, "Period", "", 1000000000, 2, Rainbow3, false, false, false, true),
						margin: this.processBarChart(result.data.data, "StatusPSO", "", "TotalMargin", false, "Period", "", 1000000000, 2, Rainbow3, false, false, false, true),
					};
				}
			})
		},
		
		async loadYTD() {
			let url = Config().apiURL + "/lpg/ytd"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.sales.length) {
					let field = 'RegionPertareId'; //SalesArea //RegionPertareId
					let prefix = 'REGION '; //AREA //REGION

					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2),
						pso: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "StatusPSO", ["PSO"]),
						nonpso: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "StatusPSO", ["NONPSO"]),
						store: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "Channel", ["STORE"]),
						spbu: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "Channel", ["SPBU"]),
						other: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "Channel", ["OTHER"]),
						keagenan: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "Source", ["SOURCE"]),
						vendor: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1000000000, 2, "Source", ["VENDOR"]),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, field, prefix, 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, field, prefix, 1000000000, 2, Rainbow, "Grup", [2], true),
					};
					
					//console.log(this.ytd.sales)
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						pso: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "StatusPSO", ["PSO"]),
						nonpso: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "StatusPSO", ["NONPSO"]),
						store: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "Channel", ["STORE"]),
						spbu: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "Channel", ["SPBU"]),
						other: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "Channel", ["OTHER"]),
						keagenan: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "Source", ["SOURCE"]),
						vendor: this.processYTD(result.data.sales, "Info", "Margin", "SalesExTax", "Grup", 1000000000, 2, "Source", ["VENDOR"]),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", field, prefix, 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", field, prefix, 0.01, 2, Rainbow, "Grup", [2], true),
					};
				}

				//console.log("result: " + JSON.stringify(this.ytd.sales.ytdchart));
			})
		},
		
		async loadKeagenan() {
			let url = Config().apiURL + "/lpg/keagenan"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.province.length) {
					this.keagenan.province = result.data.province;
					this.keagenan.total = this.sumData(result.data.province, "StoreCnt");
					this.keagenan.progress = this.createComp(result.data.progress, "Info", "Value");
				}
			})
		},
				
		async loadKeagenanList() {
			let url = Config().apiURL + "/lpg/keagenanlist"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.list.length) {
					this.keagenan.list = result.data.list;
				}
			})
		},
				
	},
}
